// extracted by mini-css-extract-plugin
module.exports = {"container":"_8GhCzWxxSr","icon":"QzmKV-3t65","value":"_3y-ZDaNyXd","message":"_10Mhux0c7V"};
    if(module.hot) {
      // 1597843257960
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  